// @/utils/campaignHtmlAdapter.js

export function normalizeCampaignHtml(html = '') {
  if (!html) return '';

  html = html.replace(/<style[^>]*>([\s\S]*?)<\/style>/gi, (match, css) => {
    const cleaned = css
      .replace(/\*\s*\{[^}]*box-sizing\s*:\s*border-box[^}]*\}/g, '')
      .replace(/body\s*\{\s*margin\s*:\s*0\s*;?\s*\}/g, '')
      .replace(/body\s*\{\s*padding\s*:\s*0\s*;?\s*\}/g, '')
      .replace(/body\s*\{\s*margin\s*:\s*0\s*;\s*padding\s*:\s*0\s*;?\s*\}/g, '')
      .trim();
    return cleaned ? `<style>${cleaned}</style>` : '';
  });

  const div = document.createElement('div');
  div.innerHTML = html;

  const adDomains = [
    'doubleclick.net',
    'google-analytics.com',
    'googlesyndication.com',
    'googletagmanager.com',
    'facebook.com/tr',
    'analytics',
    '__utm'
  ];

  div.querySelectorAll('img').forEach(img => {
    const src = img.getAttribute('src');
    if (!src) return;

    const isTracker = adDomains.some(domain => src.includes(domain));
    if (isTracker) {
      img.remove();
      return;
    }

    if (src.startsWith('/api') || src.startsWith('/storage')) {
      const baseApiUrl = process.env.VUE_APP_API_URL || window.location.origin;
      img.setAttribute('src', baseApiUrl + src);
    }

    img.style.maxWidth = '100%';
    img.style.height = 'auto';
  });

  div.querySelectorAll('script').forEach(script => {
    const src = script.getAttribute('src') || script.textContent || '';
    const isTracker = adDomains.some(domain => src.includes(domain));
    if (isTracker) script.remove();
  });
  
  div.querySelectorAll('iframe').forEach(iframe => {
    const src = iframe.getAttribute('src') || '';
    const isAd = adDomains.some(domain => src.includes(domain));
    if (isAd) iframe.remove();
  });

  return div.innerHTML;
}